<nav class="pp-wrapper">

  <button
    class="pp-button pp-prev"
    [disabled]="currentPage() === 1"
    (click)="onPreviousPageClick()"
    aria-label="Página anterior"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>

  @for ( page of pages(); track $index ) {
    <button
      class="pp-page"
      [class.active]="page === currentPage()"
      (click)="onPageClick( page )"
      [attr.aria-current]="page === currentPage() ? 'page' : null"
    >
      {{ page }}
    </button>
  }

  <button
    class="pp-button pp-next"
    [disabled]="currentPage() === totalPages()"
    (click)="onNextPageClick()"
    aria-label="Página siguiente"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>
</nav>
